<template>

  <main>
    <!-- <component :is="activePage"></component> -->
   
    <FlashMessage position="right bottom" time="5000" class="flashmsg"/>  
    <router-view/>    
  </main>
  <footer>
      <router-view name='footer'></router-view>
  </footer>
</template>

<script>
import { autoLogout } from '@/components/mixins/autoLogout.js';
export default {
  data:function() {
    return {
      activePage: 'teams-list',
      teams: [
        { id: 't1', name: 'Frontend Engineers', members: ['u1', 'u2'] },
        { id: 't2', name: 'Backend Engineers', members: ['u1', 'u2', 'u3'] },
        { id: 't3', name: 'Client Consulting', members: ['u4', 'u5'] },
      ],
      users: [
        { id: 'u1', fullName: 'Max Schwarz', role: 'Engineer' },
        { id: 'u2', fullName: 'Praveen Kumar', role: 'Engineer' },
        { id: 'u3', fullName: 'Julie Jones', role: 'Engineer' },
        { id: 'u4', fullName: 'Alex Blackfield', role: 'Consultant' },
        { id: 'u5', fullName: 'Marie Smith', role: 'Consultant' },
      ],
      currentUser:'',   
     
    };
  },
  mixins:[
    autoLogout
  ],
  provide:function() {
    return {
      teams: this.teams,
      users: this.users,
    };
  },
  methods: {
    setActivePage:function(page) {
      this.activePage = page;
    },
    deviceCheck(){
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) { 
        // 모바일인 경우 
        console.log('MOBILE');  
         const url= document.location.href;  
        //  console.log('url확인',url); 
        if(this.$store.state.sets.mode !== 'PC')
        {
          //모바일 채팅은 별도 레이아웃이라 구분 지어 준다
               
          let ckUrl = url.includes('m_chat');
          if(!ckUrl){
            this.$router.push({name:this.$store.state.menu.activeMobileMenu});
          }     
            
            //게시판 링크 일경우 m 을 붙여서 리다이렉트
          if(url.includes('community'))
          {
           
            this.$router.push(url.replace('http://gamejoa.com/main','/m'));
            //문자열 치화
            //let str = 'apple, banana, orange, banana';
              //let replaced_str = str.replace(/banana/g, 'tomato');
          }
          this.$store.state.sets.mode = 'MOBILE';
        }

        
       
        
      }else{
        this.$store.state.sets.mode = 'PC'; 
      }
    }
    
  },
  mounted:function(){   
    this.deviceCheck();
    console.log('platform', navigator.platform.toLowerCase());    
    console.log('userAgent', navigator.userAgent.toLowerCase());    
    // window.Echo.channel('home')
    //             .listen('NewMessage', (e)=>{
    //                 console.log(e.message);
    //             })
    // window.Echo.channel('DemoChannel')
    //             .listen('WebsocketDemoEvent', (e)=>{
    //                 console.log(e);
    //             })
    //             console.log(this.$store.getters.isAuthenticated)
    if(!this.currentUser)
    {
      this.$store.dispatch("logout");
    }
   
  },
  computed: {
    didAutoLogout:function() {
      return this.$store.getters.didAutoLogout;
    },  

  },
  created:function() {
    this.$store.dispatch('tryLogin');
    this.$store.dispatch('item/deleteExpirationItem');
    this.currentUser = this.$store.getters.currentUser;
    localStorage.removeItem("vuex");
    //console.log( '여기까지 온건가?'+ localStorage.getItem("vuex"));

  },
  updated(){
    document.querySelector('.active_menu').classList.remove('active_menu');
    document.querySelector('.active').classList.remove('active');
  },
  watch: {
    didAutoLogout:function(curValue, oldValue) {
      if (curValue && curValue !== oldValue) {
        this.$router.replace('/');
        window.location.reload();
      }
    }
  },
  
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");
@import '@/assets/scss/base';


</style>
